console.log("product-customize.js executed");

if (document.querySelector(".assortment--customizer")) {
  var activateAtcGlobally;
  let assortmentCustomizerElement = document.querySelector(".assortment--customizer");
  let selectedCustomizeBoxTitle = "Custom / Box of 18";
  let defaultCustomizeBoxTitle = "";
  let mainProduct_variantData = assortmentCustomizerElement.querySelector(
    '[type="application/json"][mainProduct_variantData]'
  );

  const helpTextContainer = document.querySelector(".custom-assortment-help-text");
  const helpTextOriginalContent = helpTextContainer.querySelector("span").innerHTML;
  const isPLP = location.href.includes("/collections/") && !location.href.includes("/products/");

  const atcButton = document.querySelector(
    `${
      isPLP
        ? "quick-add-modal product-form .product-form__submit"
        : "product-form .product-form__submit"
    } `
  );

  if (mainProduct_variantData) {
    mainProduct_variantData = JSON.parse(mainProduct_variantData.textContent);
    currentVariant = mainProduct_variantData.find(
      (v) => v.id == assortmentCustomizerElement.dataset.selectedCustomizedBox
    );

    if (currentVariant) {
      defaultCustomizeBoxTitle = currentVariant.title;
      selectedCustomizeBoxTitle = currentVariant.title;
    }
  }

  function getCustomBoxSelectedVariantId(mainProduct_variantData) {
    if (mainProduct_variantData) {
      return mainProduct_variantData.find((v) => v.title == selectedCustomizeBoxTitle).id;
    }
  }

  function isVariantAvaliable(mainProduct_variantData){
    if (mainProduct_variantData) {
      return mainProduct_variantData.find((v) => v.title == selectedCustomizeBoxTitle).available;
    }

    return true;
  }

  function showBackInStoreButton(){
    const backInStoreButton = document.querySelector('#BIS_trigger');
    backInStoreButton.style.display = 'initial';
    atcButton.setAttribute("disabled", "disabled");
    atcButton.querySelector("span").innerHTML = "Sold out";

    helpTextContainer.classList.remove('visibility-hidden');
  }

  function hideBackInStoreButton(){
    const backInStoreButton = document.querySelector('#BIS_trigger');
    backInStoreButton.style.display = 'none';
    atcButton.querySelector("span").innerHTML = "Add to cart";
  }

  function updateCustomBoxSelectedVariantTitle(assortmentCustomizerElement) {
    let isDefaultSetting = true;
    assortmentCustomizerElement
      .querySelectorAll('.assortment__wrapper .options input[type="number"]')
      .forEach((inputNumberElement) => {
        console.log(inputNumberElement.value);
        inputNumberElement.value = parseInt(inputNumberElement.value, 10).toString();
        if (inputNumberElement.dataset.value != inputNumberElement.value) {
          isDefaultSetting = false;
        }
      });

    if (isDefaultSetting) {
      selectedCustomizeBoxTitle = defaultCustomizeBoxTitle;
      return;
    }

    let requiredTotalCount = assortmentCustomizerElement.getAttribute("data-total-count");
    let isReachMax = false;
    assortmentCustomizerElement
      .querySelectorAll('.assortment__wrapper .options input[type="number"]')
      .forEach((inputNumberElement) => {
        console.log(inputNumberElement.value);
        inputNumberElement.value = parseInt(inputNumberElement.value, 10).toString();
        if (inputNumberElement.value == inputNumberElement.getAttribute("max")) {
          selectedCustomizeBoxTitle = `All ${inputNumberElement.id} / Box of ${requiredTotalCount}`;
          isReachMax = true;
        }
      });

    if (!isReachMax) {
      selectedCustomizeBoxTitle = `Custom / Box of ${requiredTotalCount}`;
    }
  }

  function saveChanges() {
    const assortmentCustomizerElement = document.querySelector(".assortment--customizer");
    const productId = assortmentCustomizerElement.getAttribute("data-product-id");
    const helpTextContainer = document.querySelector(".custom-assortment-help-text");
    const requiredTotalCount = assortmentCustomizerElement.getAttribute("data-total-count");

    assortmentCustomizerElement
      .querySelectorAll('input[name^="labels"]')
      .forEach((propertyElement) => {
        let elementName = propertyElement.getAttribute("name");
        let elementId = propertyElement.getAttribute("id").replace("+", "-plus");
        //not being used, will remove this later
        if (document.querySelector(`product-form input[name="${elementName}"]`)) {
          document.querySelector(`product-form input[name="${elementName}"]`).value =
            propertyElement.value;
        }
        if (document.querySelector(`product-form input#sku_${elementId}`)) {
          document.querySelector(`product-form input#sku_${elementId}`).value =
            propertyElement.value;
        }
        if (document.querySelector(`.assortment--variant-labels #assortment--${elementId} .qty`)) {
          document.querySelector(
            `.assortment--variant-labels #assortment--${elementId} .qty`
          ).innerHTML = propertyElement.value;
        }

        if (productId === "413574791211") {
          if (propertyElement.value === requiredTotalCount) {
            console.log("productId: ", productId);
            helpTextContainer.classList.remove("visibility-hidden");
            helpTextContainer.querySelector("span").innerHTML =
              'Looking for a single absorbency? Check out our <a href="/collections/periods/products/compact-plastic-applicator-tampons-20-ct">Grab & Go Tampons</a>.';
            atcButton.setAttribute("disabled", "disabled");
          }
        }

        //document.querySelector(`.customize-box--wrapper .label.${elementName} .qty`).innerHTML = propertyElement.value;
      });

    let mainProduct_variantData = assortmentCustomizerElement.querySelector(
      '[type="application/json"][mainProduct_variantData]'
    );
    mainProduct_variantData = JSON.parse(mainProduct_variantData.textContent);

    const selectedVariantId = getCustomBoxSelectedVariantId(mainProduct_variantData);
    //update the variant for one-time-purchase
    if (document.querySelector(`product-form input#variant_id`)) {
      document.querySelector(`product-form input#variant_id`).value = selectedVariantId;
    }

    updateCustomBoxSelectedVariantTitle(assortmentCustomizerElement);

    //update the variant for subscription(rc)
    if (document.querySelector(`#rc_container #rc_duplicate_selector`)) {
      //update go with your flow variant
      let subscription_goFlow_options = document.querySelectorAll(
        "#rc_container #rc_duplicate_selector option.rc_subscription_goFlow_variant_id"
      );
      subscription_goFlow_options.forEach((each) => {
        if (
          each.getAttribute("data-title") &&
          each.getAttribute("data-title") == selectedCustomizeBoxTitle
        ) {
          document.querySelector(
            `#rc_container #rc_duplicate_selector option.go_with_your_flow.rc_subscription_variant_id`
          ).value = each.value;
        }
      });

      //update delivery 3 month and 6 month variant
      let subscription_ids_json = document.querySelectorAll(
        '#rc_container [type="application/json"][subscription_variant]'
      );
      if (subscription_ids_json.length > 0) {
        subscription_ids_json.forEach((each) => {
          let variantData = JSON.parse(each.textContent);

          let newSubscriptionVariantId = variantData.find(
            (v) => v.title == selectedCustomizeBoxTitle
          );

          let index = each.getAttribute("index");
          let option = document.querySelector(
            `#rc_container #rc_duplicate_selector option.rc_subscription_variant_id.index_${index}`
          );
          option.value = newSubscriptionVariantId.id;
          option.textContent = newSubscriptionVariantId.id;
        });
      }
    }
    document.querySelector(".quick-view-assortment-popup-modal .product-popup-modal__toggle")?.click();

    if(!isVariantAvaliable(mainProduct_variantData)){
      showBackInStoreButton();
    }else{
      hideBackInStoreButton();
    }
  }

  assortmentCustomizerElement
    .querySelectorAll(".assortment__wrapper .tabs li label")
    .forEach((bulkSelector) => {
      bulkSelector.addEventListener("click", function (e) {
        let selectedBulkSelector = e.target;
        if (
          selectedBulkSelector.getAttribute("data-product-option") &&
          assortmentCustomizerElement.hasAttribute("data-total-count")
        ) {
          let totalCount = assortmentCustomizerElement.getAttribute("data-total-count");
          let productOption = selectedBulkSelector.getAttribute("data-product-option");

          selectedCustomizeBoxTitle = `All ${productOption} / Box of ${totalCount}`;

          assortmentCustomizerElement
            .querySelectorAll('.assortment__wrapper .options input[type="number"]')
            .forEach((inputNumberElement) => {
              if (inputNumberElement.getAttribute("id") == productOption) {
                inputNumberElement.value = totalCount;
              } else {
                inputNumberElement.value = 0;
              }

              inputNumberElement.value = parseInt(inputNumberElement.value, 10).toString();

              let event = new CustomEvent("forceChange");
              inputNumberElement.dispatchEvent(event);
            });

          updateCustomBoxSelectedVariantTitle(assortmentCustomizerElement);
        }
      });
    });

  assortmentCustomizerElement.querySelectorAll(".minus").forEach((minusButtonElement) => {
    let inputNumberElement = minusButtonElement.parentElement.previousElementSibling;
    let previousValue = parseInt(inputNumberElement.value, 10).toString();
    minusButtonElement.addEventListener("click", function (e) {
      let currentValue = parseInt(inputNumberElement.value, 10).toString()
        ? parseInt(inputNumberElement.value, 10).toString()
        : previousValue;
      if (currentValue > 0) {
        if (currentValue !== previousValue) {
          if (currentValue < inputNumberElement.min || currentValue > inputNumberElement.max) {
            console.log("Input value out of range!");
          } else {
            console.log("Input value changed!");
          }
        } else {
          console.log("Input value unchanged");
        }

        previousValue = currentValue;

        inputNumberElement.value -= 1;
        inputNumberElement.value = parseInt(inputNumberElement.value, 10).toString();

        var event = new CustomEvent("forceChange");
        inputNumberElement.dispatchEvent(event);
        updateCustomBoxSelectedVariantTitle(assortmentCustomizerElement);
        saveChanges();
      }
    });
  });

  assortmentCustomizerElement.querySelectorAll(".plus").forEach((plusButtonElement) => {
    let inputNumberElement = plusButtonElement.parentElement.previousElementSibling;
    let previousValue = parseInt(inputNumberElement.value, 10).toString();
    plusButtonElement.addEventListener("click", function (e) {
      let currentValue = parseInt(inputNumberElement.value, 10).toString()
        ? parseInt(inputNumberElement.value, 10).toString()
        : previousValue;

      if (currentValue !== previousValue) {
        if (currentValue < inputNumberElement.min || currentValue > inputNumberElement.max) {
          console.log("Input value out of range!");
        } else {
          console.log("Input value changed!");
        }
      } else {
        console.log("Input value unchanged");
      }

      previousValue = currentValue;

      inputNumberElement.value = parseInt(inputNumberElement.value) + 1;
      inputNumberElement.value = parseInt(inputNumberElement.value, 10).toString();

      var event = new CustomEvent("forceChange");
      inputNumberElement.dispatchEvent(event);
      updateCustomBoxSelectedVariantTitle(assortmentCustomizerElement);
      saveChanges();
    });
  });

  assortmentCustomizerElement
    .querySelectorAll('.assortment__wrapper .options input[type="number"]')
    .forEach((inputNumberElement) => {
      inputNumberElement.addEventListener("forceChange", function (e) {
        if (assortmentCustomizerElement.hasAttribute("data-total-count")) {
          let requiredTotalCount = assortmentCustomizerElement.getAttribute("data-total-count");
          let totalCount = 0;

          inputNumberElement.value = parseInt(inputNumberElement.value, 10).toString();

          if (inputNumberElement.value == requiredTotalCount) {
            document.getElementById(
              `assortment-all-${inputNumberElement.getAttribute("id")}`
            ).checked = true;
          } else {
            document.getElementById(
              `assortment-all-${inputNumberElement.getAttribute("id")}`
            ).checked = false;
          }

          assortmentCustomizerElement
            .querySelectorAll('.assortment__wrapper .options input[type="number"]')
            .forEach((inputNumberEl) => {
              assortmentCustomizerElement
                .querySelectorAll(".assortment__variants li")
                .forEach((item, index) => {
                  if (index >= totalCount && index < totalCount + parseInt(inputNumberEl.value)) {
                    item.style.backgroundColor = inputNumberEl.getAttribute("data-color");
                  } else if (index >= totalCount + parseInt(inputNumberEl.value)) {
                    item.style.backgroundColor = "#fff";
                  }
                });

              totalCount += parseInt(inputNumberEl.value);
            });

          if (totalCount >= requiredTotalCount) {
            assortmentCustomizerElement.querySelectorAll(".plus").forEach((plusButtonElement) => {
              plusButtonElement.setAttribute("disabled", "disabled");
            });
            assortmentCustomizerElement
              .querySelectorAll(".save-button")
              .forEach((saveButtonElement) => {
                saveButtonElement.innerHTML = `Save`;
                saveButtonElement.removeAttribute("disabled", "disabled");
              });
            helpTextContainer.classList.add("visibility-hidden");
            atcButton.removeAttribute("disabled");
          } else {
            assortmentCustomizerElement.querySelectorAll(".plus").forEach((plusButtonElement) => {
              plusButtonElement.removeAttribute("disabled");
            });

            assortmentCustomizerElement
              .querySelectorAll(".save-button")
              .forEach((saveButtonElement) => {
                saveButtonElement.innerHTML = `Add ${requiredTotalCount - totalCount} more to save`;
                saveButtonElement.setAttribute("disabled", "disabled");
              });

            helpTextContainer.classList.remove("visibility-hidden");
            helpTextContainer.querySelector("span").innerHTML = helpTextOriginalContent;
            atcButton.setAttribute("disabled", "disabled");
          }

          console.log("totalCount: ", totalCount);
          console.log("requiredTotalCount: ", requiredTotalCount);
          activateAtcGlobally = totalCount == requiredTotalCount;
          console.log("activateAtcGlobally: ", activateAtcGlobally);
          if (!activateAtcGlobally) {
            console.log("activateAtcGlobally false case", activateAtcGlobally);
            atcButton.setAttribute("disabled", "disabled");
          }

          if (activateAtcGlobally) {
            if (!window.location.href.includes("/tools/recurring/portal")) {
              atcButton.querySelector("span").innerHTML = "Add to cart";
            }
          }

          assortmentCustomizerElement.querySelector(
            ".custom-total"
          ).innerHTML = `<span class="custom-current-qty" style='color: ${
            totalCount == requiredTotalCount ? "#207C83" : "#C58571"
          }'>${totalCount}</span> / ${requiredTotalCount} Total ${assortmentCustomizerElement.getAttribute(
            "data-total-suffix"
          )}`;

          $("#progressbar1").LineProgressbar({
            percentage: (totalCount / requiredTotalCount) * 100,
            fillBackgroundColor: `${totalCount == requiredTotalCount ? "#207C83" : "#C58571"}`,
            animation: false,
            width: "200px",
            height: "12px",
            radius: "8px",
          });
        }
      });
    });

  assortmentCustomizerElement
    .querySelectorAll('.assortment__wrapper .options input[type="number"]')
    .forEach((inputNumberElement) => {
      let previousValue = parseInt(inputNumberElement.value, 10).toString();
      console.log("TEST previousValue: ", previousValue);

      inputNumberElement.addEventListener("input", function (e) {
        if (assortmentCustomizerElement.hasAttribute("data-total-count")) {
          let requiredTotalCount = assortmentCustomizerElement.getAttribute("data-total-count");
          let totalCount = 0;
          let inputNumElementValue =
            inputNumberElement.value == "" ? "0" : inputNumberElement.value;

          let currentValue = parseInt(inputNumElementValue, 10).toString()
            ? parseInt(inputNumElementValue, 10).toString()
            : previousValue;
          console.log("previousValue: ", previousValue);
          console.log("currentValue: ", currentValue);

          if (currentValue !== previousValue) {
            if (
              +currentValue < +inputNumberElement.min ||
              +currentValue > +inputNumberElement.max
            ) {
              console.log(
                +currentValue,
                +inputNumberElement.min,
                +inputNumberElement.max,
                "Input value out of range!"
              );
              inputNumberElement.value = 0;
              // inputNumberElement.value = parseInt(inputNumberElement.value, 10).toString();
              return;
            } else {
              console.log("Input value changed!");
            }
          } else {
            console.log("Input value unchanged");
          }

          previousValue = currentValue;

          inputNumberElement.value = parseInt(inputNumberElement.value, 10).toString();

          if (inputNumberElement.value == requiredTotalCount) {
            document.getElementById(
              `assortment-all-${inputNumberElement.getAttribute("id")}`
            ).checked = true;
          } else {
            document.getElementById(
              `assortment-all-${inputNumberElement.getAttribute("id")}`
            ).checked = false;
          }
          assortmentCustomizerElement
            .querySelectorAll('.assortment__wrapper .options input[type="number"]')
            .forEach((inputNumberEl) => {
              console.log("inputNumberEl: ", inputNumberEl.value);
              if (inputNumberEl.value) {
                assortmentCustomizerElement
                  .querySelectorAll(".assortment__variants li")
                  .forEach((item, index) => {
                    if (index >= totalCount && index < totalCount + parseInt(inputNumberEl.value)) {
                      item.style.backgroundColor = inputNumberEl.getAttribute("data-color");
                    } else if (index >= totalCount + parseInt(inputNumberEl.value)) {
                      item.style.backgroundColor = "#fff";
                    }
                  });
                totalCount += parseInt(inputNumberEl.value);
              }
              console.log("totalCount: ", totalCount);
            });
          if (totalCount == requiredTotalCount) {
            console.log("totalCount == requiredTotalCount");
            console.log("totalCount: ", totalCount);
            console.log("requiredTotalCount: ", requiredTotalCount);
            assortmentCustomizerElement.querySelectorAll(".plus").forEach((plusButtonElement) => {
              plusButtonElement.setAttribute("disabled", "disabled");
            });
            assortmentCustomizerElement
              .querySelectorAll(".save-button")
              .forEach((saveButtonElement) => {
                saveButtonElement.innerHTML = `Save`;
                saveButtonElement.removeAttribute("disabled", "disabled");
              });
            helpTextContainer.classList.add("visibility-hidden");
            atcButton.removeAttribute("disabled");
          } else if (totalCount > requiredTotalCount) {
            console.log("totalCount: ", totalCount);
            console.log("requiredTotalCount: ", requiredTotalCount);
            assortmentCustomizerElement.querySelectorAll(".plus").forEach((plusButtonElement) => {
              plusButtonElement.setAttribute("disabled", "disabled");
            });
            assortmentCustomizerElement
              .querySelectorAll(".save-button")
              .forEach((saveButtonElement) => {
                saveButtonElement.innerHTML = `Save`;
                saveButtonElement.removeAttribute("disabled", "disabled");
              });
            helpTextContainer.classList.add("visibility-hidden");
          } else {
            assortmentCustomizerElement.querySelectorAll(".plus").forEach((plusButtonElement) => {
              plusButtonElement.removeAttribute("disabled");
            });
            assortmentCustomizerElement
              .querySelectorAll(".save-button")
              .forEach((saveButtonElement) => {
                saveButtonElement.innerHTML = `Add ${requiredTotalCount - totalCount} more to save`;
                saveButtonElement.setAttribute("disabled", "disabled");
              });
            helpTextContainer.classList.remove("visibility-hidden");
            helpTextContainer.querySelector("span").innerHTML = helpTextOriginalContent;
            atcButton.setAttribute("disabled", "disabled");
          }

          activateAtcGlobally = totalCount == requiredTotalCount;
          console.log("totalCount: " + totalCount);
          console.log("requiredTotalCount: " + requiredTotalCount);
          console.log("activateAtcGlobally: ", activateAtcGlobally);
          if (!activateAtcGlobally) {
            console.log("activateAtcGlobally false case", activateAtcGlobally);
            atcButton.setAttribute("disabled", "disabled");
          }

          if (activateAtcGlobally) {
            if (!window.location.href.includes("/tools/recurring/portal")) {
              atcButton.querySelector("span").innerHTML = "Add to cart";
            }
          }
          assortmentCustomizerElement.querySelector(
            ".custom-total"
          ).innerHTML = `<span class="custom-current-qty" style='color: ${
            totalCount == requiredTotalCount ? "#207C83" : "#C58571"
          }'>${totalCount}</span> / ${requiredTotalCount} Total ${assortmentCustomizerElement.getAttribute(
            "data-total-suffix"
          )}`;
          $("#progressbar1").LineProgressbar({
            percentage: (totalCount / requiredTotalCount) * 100,
            fillBackgroundColor: `${totalCount == requiredTotalCount ? "#207C83" : "#C58571"}`,
            animation: false,
            width: "200px",
            height: "12px",
            radius: "8px",
          });
        }
        saveChanges();
      });

      inputNumberElement.addEventListener("blur", function (e) {
        console.log("blur", inputNumberElement.value);
        let currentValue = parseInt(inputNumberElement.value, 10).toString()
          ? parseInt(inputNumberElement.value, 10).toString()
          : previousValue.replace(/^0+/, "");
        console.log("previousValue: ", previousValue);
        console.log("currentValue: ", currentValue);
        if (currentValue == 0 || +previousValue == 0) {
          inputNumberElement.value = 0;
          inputNumberElement.value = parseInt(inputNumberElement.value, 10).toString();
        }
        saveChanges();
      });

      inputNumberElement.addEventListener("focus", function (e) {
        parseInt(inputNumberElement.value, 10).toString();
        console.log("focus", inputNumberElement.value);

        saveChanges();
      });
    });

  assortmentCustomizerElement.querySelectorAll(".discard").forEach((button) => {
    button.addEventListener("click", function () {
      const modalId = button.closest("modal-dialog").id,
        modalOpener = document.querySelector(`modal-opener[data-modal="#${modalId}"]`);
      modalOpener.setCustomizeDefault();
    });
  });

  assortmentCustomizerElement.querySelectorAll(".save-button").forEach((button) => {
    button.addEventListener("click", function () {
      assortmentCustomizerElement
        .querySelectorAll('input[name^="labels"]')
        .forEach((propertyElement) => {
          let elementName = propertyElement.getAttribute("name");
          let elementId = propertyElement.getAttribute("id").replace("+", "-plus");
          //not being used, will remove this later
          if (document.querySelector(`product-form input[name="${elementName}"]`)) {
            document.querySelector(`product-form input[name="${elementName}"]`).value =
              propertyElement.value;
          }
          if (document.querySelector(`product-form input#sku_${elementId}`)) {
            document.querySelector(`product-form input#sku_${elementId}`).value =
              propertyElement.value;
          }
          if (
            document.querySelector(`.assortment--variant-labels #assortment--${elementId} .qty`)
          ) {
            document.querySelector(
              `.assortment--variant-labels #assortment--${elementId} .qty`
            ).innerHTML = propertyElement.value;
          }

          //document.querySelector(`.customize-box--wrapper .label.${elementName} .qty`).innerHTML = propertyElement.value;
        });

      //update the variant for one-time-purchase
      if (document.querySelector(`product-form input#variant_id`)) {
        let selectedVariantId = getCustomBoxSelectedVariantId(mainProduct_variantData);
        document.querySelector(`product-form input#variant_id`).value = selectedVariantId;
      }

      updateCustomBoxSelectedVariantTitle(assortmentCustomizerElement);
      //update the variant for subscription(rc)
      if (document.querySelector(`#rc_container #rc_duplicate_selector`)) {
        //update go with your flow variant
        let subscription_goFlow_options = document.querySelectorAll(
          "#rc_container #rc_duplicate_selector option.rc_subscription_goFlow_variant_id"
        );
        subscription_goFlow_options.forEach((each) => {
          if (
            each.getAttribute("data-title") &&
            each.getAttribute("data-title") == selectedCustomizeBoxTitle
          ) {
            document.querySelector(
              `#rc_container #rc_duplicate_selector option.go_with_your_flow.rc_subscription_variant_id`
            ).value = each.value;
          }
        });

        //update delivery 3 month and 6 month variant
        let subscription_ids_json = document.querySelectorAll(
          '#rc_container [type="application/json"][subscription_variant]'
        );
        if (subscription_ids_json.length > 0) {
          subscription_ids_json.forEach((each) => {
            let variantData = JSON.parse(each.textContent);

            let newSubscriptionVariantId = variantData.find(
              (v) => v.title == selectedCustomizeBoxTitle
            );

            let index = each.getAttribute("index");
            let option = document.querySelector(
              `#rc_container #rc_duplicate_selector option.rc_subscription_variant_id.index_${index}`
            );
            option.value = newSubscriptionVariantId.id;
            option.textContent = newSubscriptionVariantId.id;
          });
        }
      }
    });
  });

  //This is a special request from ticket https://pthree.atlassian.net/browse/LOLA2-205.
  if (assortmentCustomizerElement.getAttribute("data-product-id") == "413605822507") {
    assortmentCustomizerElement
      .querySelectorAll('.assortment__wrapper .options input[type="number"]')
      .forEach((inputNumberElement) => {
        inputNumberElement.value = 6;
      });

    if (document.querySelector(`product-form input#variant_id`)) {
      selectedCustomizeBoxTitle = "Custom / Box of 18";
      let selectedVariantId = getCustomBoxSelectedVariantId(mainProduct_variantData);
      document.querySelector(`product-form input#variant_id`).value = selectedVariantId;
    }
  }

  //This is the subscription page pre-setting value.
  assortmentCustomizerElement
    .querySelectorAll('.assortment__wrapper .options input[type="number"]')
    .forEach((inputNumberElement) => {
      const selector = inputNumberElement.id?.replace("+", "_plus");
      const preAssortmentSetting = document.querySelector(
        `#_ReChargeForm_subscription .assortment_setting .assortment_each[data-name="${selector}"]`
      );
      if (preAssortmentSetting) {
        const preAssortmentSettingValue = preAssortmentSetting.getAttribute("data-value");
        inputNumberElement.value = preAssortmentSettingValue;
      }
    });
}

var upsellProductElement = document.querySelector(".upsell-product--wrapper .add-form-selector");
if (upsellProductElement) {
  upsellProductElement.addEventListener("click", function (e) {
    e.stopImmediatePropagation();
    if (upsellProductElement.dataset.available == "true") {
      upsellProductElement.classList.toggle("active");
    }
  });
}
